(function ($) {

    'use strict';

    var init = function () {

        manageAnalytics();

    };

    var manageAnalytics = function () {

        //Collect data for Contact Form -> ID 5, #input_5_10
        if ($('#gform_5').length > 0) {
            $('#gform_5').submit(function () {
                sessionStorage.setItem('ville-campus-5', $('#input_5_10').val());
            });
        }
        //Collect data for Plaquette Form -> ID 1, #input_1_8
        if ($('#gform_1').length > 0) {
            $('#gform_1').submit(function () {
                sessionStorage.setItem('ville-campus-1', $('#input_1_8').val());
            });
        }
        //Collect data for CV Form -> ID 2, #input_2_8
        if ($('#gform_2').length > 0) {
            $('#gform_2').submit(function () {
                sessionStorage.setItem('ville-campus-2', $('#input_2_8').val());
            });
        }
        //Collect data for Paiement Form -> ID 3, #input_3_21
        if ($('#gform_3').length > 0) {
            $(document).on("gform_page_loaded", function () {
                sessionStorage.setItem('ville-campus-3', $('#input_3_21').val());
            });
        }
        //Collect data for Paiement Form -> ID 4, #input_4_19
        if ($('#gform_4').length > 0) {
            $(document).on("gform_page_loaded", function () {
                sessionStorage.setItem('ville-campus-4', $('#input_4_19').val());
            });
        }

        $(document).on("gform_confirmation_loaded", function (e, form_id) { 
            if (form_id == 5) { 
                if(typeof gtag === 'function') {
                    gtag('event', 'formulaire', { 'event_category': 'contact', 'event_label': 'page-contact', 'dimension1': sessionStorage.getItem('ville-campus-5') }); 
                }
            } 
        });

        $(document).on("gform_confirmation_loaded", function (e, form_id) { 
            if (form_id == 1) { 
                if(typeof gtag === 'function') {
                    gtag('event', 'formulaire', { 'event_category': 'contact', 'event_label': 'telechargement-plaquette', 'dimension1': sessionStorage.getItem('ville-campus-1') }); 
                }
            } 
        });
        $(document).on("gform_confirmation_loaded", function (e, form_id) { 
            if (form_id == 2) { 
                if(typeof gtag === 'function') {
                    gtag('event', 'formulaire', { 'event_category': 'contact', 'event_label': 'deposez-votre-cv', 'dimension1': sessionStorage.getItem('ville-campus-2') }); 
                }
            } 
        });
        $('.header__social__icon--phone').click(function () { 
            if ($('.header__social__phone').hasClass('active') == false) { 
                if(typeof gtag === 'function') {
                    gtag('event', 'intention-appel', { 'event_category': 'contact', 'event_label': 'header' }); 
                }
            } 
        });
        $('.social-link').each(function () { 
            $(this).click(function () { 
                if(typeof gtag === 'function') {
                    gtag('event', 'reseaux-sociaux', { 'event_category': 'liens-sortants', 'event_label': $(this).data("social") }); 
                }
            }) 
        });
        $('.partner-link').each(function () { 
            $(this).click(function () { 
                if(typeof gtag === 'function') {
                    gtag('event', 'Partenaires', { 'event_category': 'liens-sortants', 'event_label': $(this).data("partner") }); 
                }
            }) 
        });
        $(document).on("gform_confirmation_loaded", function (e, form_id) {
            if (form_id == 3) {
                if(typeof gtag === 'function') {
                    gtag('event', 'purchase', {
                        'event_category': 'transaction',
                        'event_label': 'dossier-inscription',
                        'transaction_id': '1234',
                        'value': 100,
                        'currency': 'EUR',
                        'tax': 20,
                        'option': 'CB',
                        'dimension1': sessionStorage.getItem('ville-campus-3'),
    
                        'items': [
                            {
                                'id': '1',
                                'name': 'Frais d’inscription',
                                'price': '100'
                            }
                        ]
                    });
                }
            }
        });

    }

    $(document).ready(function () {
        init();
    });

})(jQuery);